<template>
  <!-- <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.value)">
      <span>{{ (params.value ? 'Active' : 'Inactive') }}</span>
    </vs-chip> -->
  <span class="feather-icon select-none relative switch-publish">
    <vs-switch v-model="params.data.IsPublished">
      <!--<span slot="on">Published</span>
        <span slot="off">Un-Published</span>-->
    </vs-switch>
  </span>
</template>

<script>
import con from "@/firebase/firebaseInit.ts";
export default {
  name: "CellRendererStatus",
  watch: {
    "params.data.IsPublished"() {
      this.$vs.loading();

      var self = this;
      var oldMenuDetails = [];
      con.instanceDB
        .doc("Menu")
        .get()
        .then(function (doc) {
          doc.data().AllMenu.map((menu) => {
            if (menu.MenuID != self.params.data.MenuID)
              oldMenuDetails.push(menu);
          });
          oldMenuDetails.push(self.params.data);
        });
      this.$store
        .dispatch("moduleMenuManagement/changeStatus", {
          data: [this.params.data],
          Status: this.params.data.IsPublished,
          AllMenu: oldMenuDetails,
        })
        .then(() => {
          this.$vs.loading.close();
          this.showChangeStatusSuccess();
        })
        .catch((err) => {
          this.$vs.loading.close();
          console.error(err);
          this.$vs.notify({
            color: "warning",
            //title: "Status Changed",
            text: "Something went wrong!",
          });
        });
    },
  },
  methods: {
    showChangeStatusSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Status Changed",
        text: this.params.data.IsPublished
          ? "Menu Published successfully"
          : "Menu Unpublished successfully",
      });
    },
  },
  computed: {
    chipColor() {
      return (value) => {
        if (value === true) return "success";
        else if (value === false) return "warning";
        else return "primary";
      };
    },
  },
};
</script>

<style lang="scss" scpoped>
/*.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}*/
</style>
